import { apiClient } from './client';

// Bulk AR invoice / AP bill upload (422471). Each invoice is created as a Draft through the same
// command the entry screen uses; dryRun validates everything and creates nothing.

export type InvoiceImportKind = 'AR' | 'AP';

/** One spreadsheet row = one invoice line; rows sharing invoiceRef are one invoice. */
export interface InvoiceImportRow {
  rowNumber: number;
  invoiceRef: string;
  partyCode: string | null;
  invoiceDate: string | null;
  postingDate: string | null;
  dueDate: string | null;
  supplierInvoiceNumber: string | null;
  currencyCode: string | null;
  exchangeRate: number | null;
  narration: string | null;
  locationCode: string | null;
  costCenterCode: string | null;
  accountCode: string | null;
  description: string | null;
  quantity: number;
  unitPrice: number;
  discountPercent: number;
  taxCode: string | null;
}

export interface InvoiceImportOutcome {
  invoiceRef: string;
  firstRow: number;
  partyCode: string | null;
  lineCount: number;
  total: number;
  status: 'VALID' | 'CREATED' | 'FAILED';
  errors: string[];
  documentId: string | null;
}

export interface InvoiceImportResult {
  dryRun: boolean;
  invoiceCount: number;
  okCount: number;
  failedCount: number;
  invoices: InvoiceImportOutcome[];
}

export const invoiceImportApi = {
  async run(kind: InvoiceImportKind, rows: InvoiceImportRow[], dryRun: boolean): Promise<InvoiceImportResult> {
    const r = await apiClient.post<{ data: InvoiceImportResult }>(
      `/invoice-import/${kind.toLowerCase()}`, { rows }, { params: { dryRun } });
    return r.data.data;
  },
};
